import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Person } from '../../core/model/central/person.model';
import { SubscriptionsDialogComponent } from './subscriptions-dialog.component';

@Component({
    selector: 'patient-details',
    templateUrl: './patient-details.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PatientDetailsComponent {
    @Input() selectedPatient: Person;
    @Input() hasTwoWay: boolean;

    constructor(private modalService: BsModalService) {
    }

    openSubscriptionsDialog(destinator): void {

        const initialState = {
            selectedDestinator: destinator,
            selectedPatient: this.selectedPatient
        };

        this.modalService.show(SubscriptionsDialogComponent,
            {
                initialState,
                backdrop: 'static',
                class: 'modal-lg',
                keyboard: false // disable esc key
            });
    }
}
